import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminLogin, adminLogout, adminMe } from "@/lib/adminApi";

const AdminAuthContext = createContext(null);

// Admin-only session (httpOnly cookie). Completely separate from future Whop member auth.
export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    adminMe().then(setAdmin).catch(() => setAdmin(false));
  }, []);

  const login = useCallback(async (username, password) => {
    const res = await adminLogin(username, password);
    setAdmin(res.user);
    return res.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await adminLogout();
    } finally {
      setAdmin(false);
    }
  }, []);

  return <AdminAuthContext.Provider value={{ admin, login, logout }}>{children}</AdminAuthContext.Provider>;
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
